import appLogo from 'Assets/img/appLogo.png';

/**
 * App Config File
 */
const AppConfig = {
  appLogo, // App Logo
  brandName: 'NAYA', // Brand Name
  navCollapsed: true, // Sidebar collapse
  fieldCollapsed: true, // Sidebar collapse
  notificationCollapsed: true, // Sidebar collapse
  sidebarShrink: false, // Sidebar collapse
  enableThemeOptions: true, // Enable Theme Options
  country: 'ko',
  locale: {
    languageId: 'korean',
    locale: 'ko',
    name: 'Korean',
    icon: 'ko',
  },
  languages: {
    en: {
      languageId: 'english',
      locale: 'en',
      name: 'English',
      icon: 'en',
    },
    ko: {
      languageId: 'korean',
      locale: 'ko',
      name: 'Korean',
      icon: 'ko',
    },
    vi: {
      languageId: 'vietnamese',
      locale: 'vi',
      name: 'Vietnamese',
      icon: 'vi',
    },
  },
  copyRightText: 'NAYA © 2020 All Rights Reserved.', // Copy Right Text
  // light theme colors
  themeColors: {
    primary: '#5D92F4',
    secondary: '#677080',
    success: '#00D014',
    danger: '#FF3739',
    warning: '#FFB70F',
    info: '#00D0BD',
    dark: '#464D69',
    default: '#FAFAFA',
    grayLighten: '#A5A7B2',
    gray: '#677080',
    white: '#FFFFFF',
    purple: '#896BD6',
    yellow: '#D46B08',
  },
};

export default AppConfig;
